import React from "react";
import { useQuery } from "@tanstack/react-query";

import { AssetGalleryManager } from "components/admin";
import { useAuth } from "context/auth-context";
import { workspaceApi } from "pages/app/workspace/services";
import { SchoolTeamProfileTabProps } from "pages/app/workspace/school-team-profile/school-team-profile.types";
import { hasAnyPortalAction } from "utils/portal-access";

export const SchoolTeamMediaTab: React.FC<SchoolTeamProfileTabProps> = ({ schoolId, teamId }) => {
  const { portalAccess } = useAuth();
  const galleryQuery = useQuery({
    queryKey: ["school-team-profile-gallery", teamId],
    queryFn: () => workspaceApi.galleryItems.listSchoolTeam(teamId),
    enabled: Boolean(teamId),
  });

  const canManageTeamGallery = hasAnyPortalAction(portalAccess, [
    "school_team_gallery.manage",
    "school_teams.update",
    "school_teams.manage",
  ]);

  const galleryInvalidateKeys = [
    ["school-team-profile-gallery", teamId],
    ["school-team-profile-dashboard", teamId],
    ["workspace-school-team-gallery", teamId],
    ["workspace-school-team-dashboard", teamId],
    ["workspace-school-teams", schoolId],
  ].filter((queryKey) => Boolean(queryKey[1]));

  return (
    <AssetGalleryManager
      canManage={canManageTeamGallery}
      createLabel="Add team asset"
      emptyDescription="Team gallery items will appear here once assets are added."
      invalidateKeys={galleryInvalidateKeys}
      isLoading={galleryQuery.isLoading}
      items={galleryQuery.data || []}
      onCreate={(payload) => workspaceApi.galleryItems.createSchoolTeam(teamId, payload)}
      onRemove={(item) => workspaceApi.galleryItems.remove(String(item.id))}
      onUpdate={(item, payload) => workspaceApi.galleryItems.update(String(item.id), payload)}
      subtitle="Keep matchday photography, clips, posters, and featured squad visuals together."
      title="Team Gallery"
    />
  );
};
